import request from '@/router/axios';

const base = '/api/produce/data-statistics/customer-value';

export const getCustomerValueSummary = (data) => request({
  url: `${base}/summary`,
  method: 'post',
  data,
});

export const getCustomerValuePage = (data) => request({
  url: `${base}/page`,
  method: 'post',
  data,
});

export const getCustomerValueDetail = (params) => request({
  url: `${base}/detail`,
  method: 'get',
  params,
});

export const getCustomerOptions = (params) => request({
  url: '/api/produce/blade-dept/select/distinct/select',
  method: 'get',
  params,
});

export const getLegacyList = (data) => request({
  url: '/api/produce/data-statistics/selectCustValue/page',
  method: 'post',
  data,
});
